import React from 'react';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Icon, { IIconProps } from 'tbk-components/src/components/Icon';

export interface infoLine {
	icon?: IIconProps;
	text?: string;
}

export interface IShopCardProps {
	shopLogo?: IImage;
	shopNameOrInfo?: string;
	cta?: ILink;
	infoLines?: infoLine[];
}

const ShopCard: React.FC<IShopCardProps> = ({
	shopLogo,
	shopNameOrInfo,
	cta,
	infoLines,
}) => {
	return (
		<div className="shop-card__container">
			<div className="shop-card__container-inner">
				{shopLogo && (
					<div className="shop-card__logo">
						<Image {...shopLogo} />
					</div>
				)}
				{shopNameOrInfo && <span>{shopNameOrInfo}</span>}
				{cta?.href && <Button {...cta} />}
				{infoLines?.length > 0 && (
					<div className="shop-card__info">
						{infoLines.map((info, index) => (
							<div key={index}>
								{info?.icon?.name && <Icon {...info?.icon} />}
								{info?.text && <span>{info?.text}</span>}
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

export default ShopCard;
